import { useState, useEffect } from 'react';
import { CircleDollarSign, RefreshCw, ArrowDownLeft, ArrowUpRight, TrendingUp, Info } from 'lucide-react';
import { PageShell, StatCard, fmtINR, fmtDate, Spinner, useBanner, useWalletUser, BtnPrimary } from './WalletShared';
import walletController from '../../controllers/walletController';

const WalletBalance = () => {
  const { userId } = useWalletUser();
  const { banner, notify, clearBanner } = useBanner();
  const [data, setData]         = useState(null);
  const [loading, setLoading]   = useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const load = async (silent=false) => {
    if (!silent) setLoading(true); else setRefreshing(true);
    const res = await walletController.getBalance(userId);
    if (res.success) setData(res.data);
    else notify('error', res.message);
    setLoading(false); setRefreshing(false);
  };
  useEffect(() => { load(false); }, [userId]);

  if (loading) return <div style={{ display:'flex', justifyContent:'center', alignItems:'center', minHeight:'60vh', gap:10, color:'#64748b' }}><Spinner size={28}/><span>Loading balance…</span></div>;

  const BALANCE_ITEMS = [
    { key:'available', label:'Available',      color:'#15803d', desc:'Ready to use' },
    { key:'pending',   label:'Pending',        color:'#92400e', desc:'Processing' },
    { key:'locked',    label:'Locked',         color:'#b91c1c', desc:'On hold' },
    { key:'cashback',  label:'Cashback',       color:'#0f6e56', desc:'Earned rewards' },
    { key:'credit',    label:'Credit Limit',   color:'#1d4ed8', desc:'Available credit' },
  ];

  return (
    <PageShell title="Balance" subtitle="Detailed balance breakdown" icon={CircleDollarSign}
      banner={banner} onCloseBanner={clearBanner}
      actions={
        <>
          <button onClick={() => load(true)} disabled={refreshing} style={{ display:'flex', alignItems:'center', gap:5, padding:'7px 12px', background:'#fff', border:'1px solid #e2e8f0', borderRadius:8, fontSize:12, cursor:'pointer', color:'#475569' }}>
            <RefreshCw size={13} style={{ animation:refreshing?'spin 1s linear infinite':'none' }}/> Refresh
          </button>
          <a href="/dashboard/wallet/add-money" style={{ display:'flex', alignItems:'center', gap:5, padding:'7px 14px', background:'#15803d', color:'#fff', borderRadius:8, fontSize:12, fontWeight:600, textDecoration:'none' }}>
            <ArrowDownLeft size={14}/>Add Money
          </a>
          <a href="/dashboard/wallet/withdraw" style={{ display:'flex', alignItems:'center', gap:5, padding:'7px 14px', background:'#1e293b', color:'#fff', borderRadius:8, fontSize:12, fontWeight:600, textDecoration:'none' }}>
            <ArrowUpRight size={14}/>Withdraw
          </a>
        </>
      }>

      {/* Balance cards */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:14, marginBottom:24 }}>
        {BALANCE_ITEMS.map(({ key, label, color, desc }) => (
          <div key={key} style={{ background:'#fff', borderRadius:12, padding:'18px 16px', border:'1px solid #f1f5f9', borderLeft:`4px solid ${color}` }}>
            <div style={{ fontSize:11, color:'#64748b', marginBottom:4, fontWeight:500 }}>{label}</div>
            <div style={{ fontSize:24, fontWeight:700, color, marginBottom:4 }}>{fmtINR(data?.[key]||0)}</div>
            <div style={{ fontSize:11, color:'#94a3b8' }}>{desc}</div>
          </div>
        ))}
      </div>

      {/* Monthly summary */}
      {data?.monthly && (
        <div style={{ background:'#fff', borderRadius:12, border:'1px solid #f1f5f9', overflow:'hidden' }}>
          <div style={{ padding:'14px 18px', borderBottom:'1px solid #f1f5f9' }}>
            <span style={{ fontSize:14, fontWeight:700, color:'#1e293b' }}>Monthly Summary</span>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:0 }}>
            {(data.monthly||[]).map((m,i) => (
              <div key={i} style={{ padding:'14px 18px', borderBottom:'1px solid #f8fafc', borderRight:'1px solid #f8fafc' }}>
                <div style={{ fontSize:12, color:'#94a3b8', marginBottom:4 }}>{m.month}</div>
                <div style={{ display:'flex', gap:16, fontSize:13 }}>
                  <span style={{ color:'#15803d', fontWeight:600 }}>+{fmtINR(m.in)}</span>
                  <span style={{ color:'#b91c1c', fontWeight:600 }}>-{fmtINR(m.out)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </PageShell>
  );
};
export default WalletBalance;